import React from 'react';
import { Col, Grid, Row } from 'antd';
import ImageC from 'src/components/Image';
import CollapsibleList from 'src/components/TerapiRegeneratif/CollapsibleList';
import panelsData from 'src/utils/dummy/stemcell/faq';
import cn from "src/utils/cn";

const FAQ = () => {
	const { md, xxl } = Grid.useBreakpoint();

	return (
		<div className="bg-white py-12">
			<div className="container">
				{md && (
					<h2 className="text-5xl font-bold max-xl:text-2xl max-xs:mt-6 max-xs:text-xl max-xs:font-semibold max-xs:leading-7">
						FAQ
					</h2>
				)}
				<Row gutter={{ md: 60, xs: 0 }}>
					{!md && (
						<Col className="flex justify-center" xs={24}>
							<div>
								<ImageC
									style={{ objectFit: 'cover' }}
									width={400}
									height={400}
									src="/images/stem-cell/cells-square.png"
								/>
							</div>
						</Col>
					)}
					<Col md={12} xs={24}>
						{!md && (
							<h2 className="text-5xl font-bold max-xl:text-2xl max-xs:mt-6 max-xs:text-xl max-xs:font-semibold max-xs:leading-7">
								FAQ
							</h2>
						)}
						<CollapsibleList panels={panelsData} />
					</Col>
					{md && (
						<Col className="flex justify-center" md={12}>
							<div>
								<ImageC
									style={{ objectFit: 'cover' }}
									width={xxl ? 550 : 400}
									height={xxl ? 550 : 400}
									src="/images/stem-cell/cells-square.png"
								/>
							</div>
						</Col>
					)}
				</Row>
			</div>
		</div>
	);
};

export default FAQ;
